/* unplugin-vue-components disabled */import { render } from "./LayoutSwitch.vue?vue&type=template&id=781a19eb&ts=true"
import script from "./LayoutSwitch.vue?vue&type=script&lang=ts"
export * from "./LayoutSwitch.vue?vue&type=script&lang=ts"

import "./LayoutSwitch.vue?vue&type=style&index=0&id=781a19eb&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__